import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingService } from './services/loading.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { TranslationService } from './services/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'san-antonio-angular';
  language: string = 'es';

  constructor(
    private router: Router,
    public loadingService: LoadingService,
    private titleService: Title,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        this.handleTitle(item.url);
      }
    });

    this.translationService.initLanguage();
  }

  handleTitle(url: string) {
    const urlParts = url.split('/');
    const title = urlParts[2];

    if (!title) {
      this.titleService.setTitle(`${environment.title}`);
      return;
    }

    switch (title) {
      case 'account':
        this.titleService.setTitle(`Account - ${environment.title}`);
        break;

      case 'all-questionnaires':
        this.titleService.setTitle(`Questionnaires - ${environment.title}`);
        break;

      case 'home':
        this.titleService.setTitle(`Questionnaire - ${environment.title}`);
        break;

      case 'questionnaire':
        this.titleService.setTitle(`Form - ${environment.title}`);
        break;

      case 'report':
        this.titleService.setTitle(`Report - ${environment.title}`);
        break;

      case 'submission':
        this.titleService.setTitle(`Submission - ${environment.title}`);
        break;

      case 'login':
        this.titleService.setTitle(`Login - ${environment.title}`);
        break;

      case 'recover':
        this.titleService.setTitle(`Recover - ${environment.title}`);
        break;

      default:
        this.titleService.setTitle(`${environment.title}`);

        break;
    }
  }
}
